export default __webpack_public_path__ + "static/media/EM1780.34I-43286_-25871_0.ae1a0075.jpg";